// extracted by mini-css-extract-plugin
export default {"container":"RefundPolicy_container__gbYde"};